import React from "react";
import "./HeaderComponent.css";

import HeroHeadline from "./HeroHeadline";
import HeroStakeholderCards from "./HeroStakeholderCards";
import HeroVideoBackground from "./HeroVideoBackground";
import EventMarquee from "../EventMarquee/EventMarquee";
import WhatWeOffer from "../WhatWeOffer/WhatWeOffer";

const HeaderComponent = () => (
  // `!pt-0` overrides the legacy `.mainHeaderComponent { padding-top: 5vh }`.
  <div
    id="about"
    className="mainHeaderComponent relative overflow-hidden bg-surface !pt-0"
  >
    {/* Hero top spacing lives here alone. The legacy stylesheet split it across
        `.mainHeaderComponent` (vh) and `.Typewriter` (px) inside width-range
        media queries, so the gap collapsed at 651-767px and 1311-1710px. */}
    <div className="hero-grid-bg relative z-10 w-full flex flex-col items-center pt-14 sm:pt-16 md:pt-[90px] pb-12">
      {/* Sits at z-[-2], one layer below the grid's `::before` at z-[-1], so
          the grid lines read over the footage. */}
      <HeroVideoBackground />

      <HeroHeadline />
      <HeroStakeholderCards />
    </div>

    {/* Stays directly under the cards. It is inside the fold because the hero
        block above reserves room for it — see the fold sum in the stylesheet,
        which subtracts this strip's pinned 40px as well as the navbar's 95. */}
    <EventMarquee />

    <WhatWeOffer />
  </div>
);

export default HeaderComponent;
